import { useEffect, useState } from "react";

import Copy from "../Copy"

const CurlSnippet = (props) => {
    const [code, setCode] = useState({});

    useEffect(() => {
        const iat = Math.floor(Date.now() / 1000);
        const exp = Math.floor((Date.now() + 24 * 60 * 60 * 1000) / 1000);
        const code = {
            "kid": `${props?.signingKeyId ? props.signingKeyId : ""}`,
            "aud": `${props?.playbackId && props?.product === "vod" ? (props?.selectedFeature === "drmLicense" ? `drm:${props?.playbackId}` : `media:${props?.playbackId}`) : ""}`,
            "iss": "fastpix.com",
            "iat": iat,
            "exp": exp
        };
        setCode(code)
    }, [props])

    return (
        <div className={`flex flex-col ${props?.heading ? "bg-[#11223D] text-white-1 text-opacity-80" : "bg-[#FFFFFF] text-[#333333]"} border-[1px] border-[#E2E8F0] items-start self-stretch rounded-[8px] overflow-hidden w-full relative`}>
            {props?.heading &&
                <div className="w-full flex  items-center text-white-1 font-medium h-[49px] bg-[#20304A] tab font-basier text-base px-[15px] text-light-white-1 py-1 gap-[5px]">
                    <span className="truncate text-[18px] font-medium leading-[28.8px] ">{props?.heading}</span>
                </div>
            }
            <div className="overflow-auto w-full flex flex-col items-start gap-1  bg-dark-blue">
                {props?.heading &&
                    <div className="absolute top-[15px] right-4">
                        <div className="w-full flex items-start">
                            <span className="text-white-1 text-[14px] font-medium leading-[19.6px] absolute right-4 bottom-[-3px] mr-[10px]">COPY</span>
                            <Copy text={props?.jwt ? props?.jwt : JSON.stringify(code, null, 2)} hideText iconColor="text-white-1" />
                        </div>
                    </div>
                }
                <div className="tab-content-item text-sm py-[10px] px-[20px] w-full">
                    <pre className={`javascript line-numbers whitespace-wrap w-full ${props?.jwt === "" && "flex flex-col justify-center items-center min-h-[100px] text-[15] font-medium text-error"}`}>
                        <code className={`javascript ${props?.jwt ? "whitespace-pre-line" : ""} break-all `}>{props?.jwt ? props?.jwt : props?.jwt === "" ? "Enter Required Values" : JSON.stringify(code, null, 2)}</code>
                    </pre>
                </div>
            </div>
        </div>
    )
}

export default CurlSnippet
